angular
    .module('ib-shared-services-module', []);
